import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Stack,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { memo, useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import CallIcon from '@mui/icons-material/Call';
import ModalPDF from "../../components/ModalPDF";

const CardServicio = ({ contenido }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
    const [openModal, setOpen] = useState(false);
    const [currentPdf, setCurrentPdf] = useState(null);

    const handleOpenModal = (encontrarArchivo) => {
    setCurrentPdf(encontrarArchivo);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const categorias = [
    contenido.tipo,
    contenido.subtipo,
    contenido.subtipo_1,
  ].filter(Boolean);

  const descripciones = [
    contenido.subtitulo,
    contenido.subtitulo_2,
    contenido.subtitulo_3,
  ].filter(Boolean);

  return (
    <Grid
      sx={{
        display: "flex",
        justifyContent: "center",
        paddingLeft: "0 !important",
        maxWidth: "100% !important",
      }}
    >
      {/* CONTENEDOR CON PERSPECTIVA */}
      <Box
        sx={{
          perspective: "1200px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card className="card-container" sx={{
          height: "540px",
          width: "100%",
          maxWidth: "350px",
          display: "flex",
          flexDirection: "column",
          transformStyle: "preserve-3d",
          transition: "transform 0.6s ease, box-shadow 1s ease, opacity 1s ease",
          boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
          overflow: "visible",
            
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            zIndex: -1, 
            opacity: 0, 
            transition: "opacity 1s ease-in-out",
            borderRadius: "9px",
          },
          "&:hover": {
            boxShadow: "0 25px 45px rgba(0,0,0,0.35)",
            transform: "rotateX(15deg) translateY(-5%)",
          },

          "&:hover::before": {
            opacity: 1,
          },
        }}>

          <Box className="wrapper" sx={{
            width: "100%",
            height: "0%",
            transition: "all 0.8s",
          }}>

            {/* IMAGEN */}
            <CardMedia sx={{
              height: 110,
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
              opacity: 1,
              transform: "translateZ(20px)",
              transition: "transform 0.7s ease, opacity 0.5s ease",

              ".MuiCard-root:hover &": {
                opacity: 0,
                transitionDelay: "0.2s"
              },
            }}>
              <img
                src={contenido.image}
                alt={contenido.image}
                height="100px"
              />
            </CardMedia>

            <Typography
              variant="h6"
              textAlign="center"
              sx={{
                mt: 2.5,
                fontWeight: 700,
                color: "#183153",
                lineHeight: 1.2,
                minHeight: 58,
                maxWidth: "270px",
                placeSelf: "center"
            }}>
              {contenido.titulo}
            </Typography>

            <Divider sx={{
              borderStyle: "dashed",
              borderColor: "#D8D8D8",
            }}/>

            {/* CONTENIDO */}
            <CardContent sx={{
              py: 1,
              px: 3,
            }}>
              <Typography
                variant="overline"
                sx={{
                  color: "#06C7F9",
                  fontWeight: 700,
                  letterSpacing: 1.5,
              }}>
                DESCRIPCION
              </Typography>

              <Stack spacing={1} mt={1}>
                {descripciones.length > 0 ? (
                  descripciones.map((texto, index) => (

                    <Box
                      key={index}
                      display="flex"
                      alignItems="center"
                    >
                      <Box
                        sx={{
                          width: 7,
                          height: 7,
                          borderRadius: "50%",
                          bgcolor: "#06C7F9",
                          mr: 1.5,
                          flexShrink: 0,
                      }}/>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        {texto}
                      </Typography>

                    </Box>
                  ))

                ) : (

                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    Información disponible al consultar el PDF.
                  </Typography>

                )}
              </Stack>
            </CardContent>

            <CardContent sx={{
              pt: 1,
              pb: 2,
              px: 3,
              flexGrow: 1,
            }}>
              <Typography
                variant="overline"
                sx={{
                  color: "#06C7F9",
                  fontWeight: 700,
                  letterSpacing: 1.5,
              }}>
                TIPO DE SERVICIO  
              </Typography>

              <Stack
                direction="row"
                spacing={1}
                useFlexGap
                flexWrap="wrap"
                mt={1.5}
              >
                {categorias.map((categoria, index) => (
                  <Chip
                    key={index}
                    label={categoria}
                    sx={{
                      bgcolor: "#EAF9FF",
                      color: "#0B5E8E",
                      fontWeight: 600,
                      borderRadius: "10px",
                      border: "1px solid #C7EEFA",
                      transition: ".30s",

                      "&:hover": {
                        bgcolor: "#06C7F9",
                        color: "#FFF",
                      },
                    }}
                  />
                ))}
              </Stack>

              {/* Tarjeta informativa */}

              <CardMedia
                mt={3}
                sx={{
                  bgcolor: "#F8FBFD",
                  border: "1px dashed #D8E4EC",
                  borderRadius: "14px",
                  mt: 1,
                  p: 1,
                  opacity: 1,
                  transition: ".30s",
                  ".MuiCard-root:hover &": {
                    opacity: 0,
                    transitionDelay: "0.2s"
                  },
              }}>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  color="primary"
                >
                  Conoce mas de nuestro servicios
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  mt={0.5}
                >
                  Consulta la información de este servicio en el boton "MAS DETALLES" o comunícate
                  directamente con uno de nuestros asesores al {contenido.telefono}.
                </Typography>
              </CardMedia>
            </CardContent>
          </Box>

          {/* IMAGEN (animacion) */}
          <CardMedia sx={{
            padding: "0",
            display: "flex",
            alignSelf: "center",
            opacity: 0,
            transition: "transform 1.1s ease, opacity 0.5s ease",
            position: "absolute",
            top: "10px",
            pointerEvents: "none",
            borderRadius: "50%",

            ".MuiCard-root:hover &": {
              transform: "translateY(-50px) rotateX(-30deg) translateZ(100px)",
              opacity: 1,
              transitionDelay: "0.4s",
              //boxShadow: "0 25px 25px rgba(0,0,0,0.40)",
            },
          }}>
            <img
              src={contenido.image}
              alt="imagen-animacion"
              height="125px"
            /> 
          </CardMedia> 

          {/* Contenido (animacion) */}
          <CardContent sx={{
            borderRadius: "10px",
            width:"100%",
            maxWidth: "220px",
            height:"50px",
            padding: "0 !important",
            alignSelf: "center",
            opacity: 0,
            transition: "transform 1.1s ease, opacity 0.5s ease",
            position: "absolute",
            top: "450px",
            display: "flex",
            flexDirection: "row",
            border: "2px solid black",
  
            ".MuiCard-root:hover &": {
              transform: "translateY(-30px) rotateX(-15deg) translateZ(100px)",
              opacity: 1,
              transitionDelay: "0.4s",
              boxShadow: "0 25px 25px rgba(0,0,0,0.40)",
            },
          }}>
            <Button
              component="a"
              href={"tel:"+ contenido.numero}
              sx={{ 
                padding: "4px", 
                textDecoration: "none",
                borderRadius: "7px 0 0 7px",
                width:"60%",
                bgcolor:"primary.deep",
                transition: "all 0.5s ease",
                "&:hover": {
                  bgcolor:"#ffffff",

                  "& .text1": {
                    color: "black",
                  },

                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                }
            }}>
              <CallIcon sx={{color: "white", width: "25px", paddingRight:"8px", transition: "all 0.7s ease"}} />
              <Typography className="text1" sx={{color: "white", fontSize: "10px", transition: "all 0.7s ease"}}>{contenido.telefono}</Typography>
            </Button>

            <Button
              component="a"
              onClick={() => handleOpenModal(contenido.pdf)}
              sx={{ 
                padding: "4px", 
                textDecoration: "none",
                borderRadius: "0 7px 7px 0",
                borderLeft: "2px solid #fff",
                width:"40%",
                bgcolor:"primary.deep",
                transition: "all 0.5s ease",
                "&:hover": {
                  bgcolor:"#ffffff",

                  "& .text2": {
                    color: "black",
                  },

                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                }
            }}>
              <InfoIcon sx={{color: "white", width: "25px", paddingRight:"8px", transition: "all 0.7s ease"}} />
              <Typography className="text2" sx={{color: "white", fontSize: "10px", transition: "all 0.7s ease"}}>MAS DETALLES</Typography>
            </Button>
          </CardContent>
        </Card>

        <ModalPDF
          open={openModal}
          handleClose={handleCloseModal}
          pdfOriginal={currentPdf}
        /> 
      </Box>
    </Grid>
  );
};

export default memo(CardServicio);
